// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__12PAc","label":"SetPasswdForm_label__2Elbg"};